'use client';

import { c as _c } from "react/compiler-runtime";
import { useDecisions } from '../../hooks';
import { AfterPayLegacy } from './AfterPay.legacy';
export const AfterPayScript = () => {
  const $ = _c(1);
  const isOneTrust = useDecisions("onetrust");
  if (isOneTrust) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <AfterPayLegacy />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};